/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './project.component.scss.shim.ngstyle';
import * as import1 from '../shared/subheading.scss.shim.ngstyle';
import * as import2 from '@angular/core';
import * as import3 from '../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as import4 from '@angular/material';
import * as import5 from '@angular/common';
import * as import6 from '../../../../src/app/shared/grid-scale-in.directive';
import * as import7 from '../../../../src/app/project/project.component';
import * as import8 from '../../../../src/app/core/project.service';
const styles_ProjectComponent:any[] = [
  import0.styles,
  import1.styles
]
;
export const RenderType_ProjectComponent:import2.RendererType2 = import2.ɵcrt({
  encapsulation: 0,
  styles: styles_ProjectComponent,
  data: {}
}
);
function View_ProjectComponent_2(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(8388608,(null as any),(null as any),8,'a',[
      [
        'md-icon-button',
        ''
      ]
      ,
      [
        'mdTooltip',
        'Collaborative work'
      ]
      ,
      [
        'target',
        '_blank'
      ]

    ]
    ,[
      [
        8,
        'href',
        4
      ]
      ,
      [
        1,
        'disabled',
        0
      ]
      ,
      [
        1,
        'aria-disabled',
        0
      ]
      ,
      [
        8,
        'tabIndex',
        0
      ]
      ,
      [
        2,
        'mat-icon-button',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'click'
      ]
      ,
      [
        (null as any),
        'longpress'
      ]
      ,
      [
        (null as any),
        'touchend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import2.ɵnov(v,2)._haltDisabledEvents($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('longpress' === en)) {
        const pd_1:any = ((<any>import2.ɵnov(v,4).show()) !== false);
        ad = (pd_1 && ad);
      }
      if (('touchend' === en)) {
        const pd_2:any = ((<any>import2.ɵnov(v,4).hide(1500)) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },import3.View_MdAnchor_0,import3.RenderType_MdAnchor)),
      import2.ɵdid(8192,(null as any),0,import4.MdPrefixRejector,[[
        2,
        import4.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    import2.ɵdid(90112,(null as any),0,import4.MdAnchor,[
      import2.ElementRef,
      import2.Renderer,
      import4.FocusOriginMonitor
    ]
    ,(null as any),(null as any)),
    import2.ɵdid(8192,(null as any),0,import4.MdIconButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
    import2.ɵdid(106496,(null as any),0,import4.MdTooltip,[
      import4.Overlay,
      import2.ElementRef,
      import4.ScrollDispatcher,
      import2.ViewContainerRef,
      import2.NgZone,
      import2.Renderer,
      import4.Platform,
      [
        2,
        import4.Dir
      ]

    ]
      ,{message: [
        0,
        'message'
      ]
    },(null as any)),
      (l()(),import2.ɵeld(0,(null as any),0,3,'md-icon',[[
        'role',
        'img'
      ]
      ],[[
        2,
        'mat-icon',
        (null as any)
      ]
    ],(null as any),(null as any),import3.View_MdIcon_0,import3.RenderType_MdIcon)),
      import2.ɵdid(8192,(null as any),0,import4.MdPrefixRejector,[[
        2,
        import4.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    import2.ɵdid(4513792,(null as any),0,import4.MdIcon,[
      import2.ElementRef,
      import2.Renderer,
      import4.MdIconRegistry
    ]
    ,(null as any),(null as any)),
    (l()(),import2.ɵted(0,['people'])),
    (l()(),import2.ɵand(0,(null as any),(null as any),0))
  ]
  ,(ck,v) => {
    const currVal_5:any = 'Collaborative work';
    ck(v,4,0,currVal_5);
    ck(v,7,0);
  },(ck,v) => {
    const currVal_0:any = (<any>v.parent).context.$implicit.github;
    const currVal_1:any = import2.ɵnov(v,2).disabled;
    const currVal_2:any = import2.ɵnov(v,2)._isAriaDisabled;
    const currVal_3:any = import2.ɵnov(v,2).tabIndex;
    const currVal_4:any = true;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
    const currVal_6:any = true;
    ck(v,5,0,currVal_6);
  });
}
function View_ProjectComponent_3(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'bullet bullet--technology'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit;
    ck(v,1,0,currVal_0);
  });
}
function View_ProjectComponent_4(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'bullet bullet--integration'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit;
    ck(v,1,0,currVal_0);
  });
}
function View_ProjectComponent_1(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),27,'md-grid-tile',[
      [
        'class',
        'tile'
      ]
      ,
      [
        'role',
        'listitem'
      ]

    ]
      ,[[
        2,
        'mat-grid-tile',
        (null as any)
      ]
    ],(null as any),(null as any),import3.View_ɵm_0,import3.RenderType_ɵm)),
      import2.ɵdid(8192,(null as any),0,import4.MdPrefixRejector,[[
        2,
        import4.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
      import2.ɵdid(24576,[[
        1,
        4
      ]
    ],0,import4.ɵm,[
      import2.Renderer,
      import2.ElementRef
    ]
    ,(null as any),(null as any)),
      (l()(),import2.ɵeld(0,(null as any),0,0,'img',[[
        'class',
        'thumbnail'
      ]
    ],[
      [
        8,
        'src',
        4
      ]
      ,
      [
        8,
        'alt',
        0
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any))),
      (l()(),import2.ɵeld(0,(null as any),0,23,'div',[[
        'class',
        'info'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import2.ɵeld(0,(null as any),(null as any),3,'h3',[[
        'class',
        'title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '',
      ' '
    ]
    )),
    (l()(),import2.ɵand(8388608,(null as any),(null as any),1,(null as any),View_ProjectComponent_2)),
    import2.ɵdid(8192,(null as any),0,import5.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'subtitle'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '',
      ''
    ]
    )),
      (l()(),import2.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'bullets'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵand(8388608,(null as any),(null as any),1,(null as any),View_ProjectComponent_3)),
    import2.ɵdid(401408,(null as any),0,import5.NgForOf,[
      import2.ViewContainerRef,
      import2.TemplateRef,
      import2.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import2.ɵand(8388608,(null as any),(null as any),1,(null as any),View_ProjectComponent_4)),
    import2.ɵdid(401408,(null as any),0,import5.NgForOf,[
      import2.ViewContainerRef,
      import2.TemplateRef,
      import2.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
      (l()(),import2.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'actions'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵeld(0,(null as any),(null as any),4,'a',[
      [
        'md-button',
        ''
      ]
      ,
      [
        'target',
        '_blank'
      ]

    ]
    ,[
      [
        8,
        'href',
        4
      ]
      ,
      [
        1,
        'disabled',
        0
      ]
      ,
      [
        1,
        'aria-disabled',
        0
      ]
      ,
      [
        8,
        'tabIndex',
        0
      ]
      ,
      [
        2,
        'mat-button',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import2.ɵnov(v,19)._haltDisabledEvents($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_MdAnchor_0,import3.RenderType_MdAnchor)),
      import2.ɵdid(8192,(null as any),0,import4.MdPrefixRejector,[[
        2,
        import4.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    import2.ɵdid(90112,(null as any),0,import4.MdAnchor,[
      import2.ElementRef,
      import2.Renderer,
      import4.FocusOriginMonitor
    ]
    ,(null as any),(null as any)),
    import2.ɵdid(8192,(null as any),0,import4.MdButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
    (l()(),import2.ɵted(0,['SOURCE'])),
    (l()(),import2.ɵted((null as any),[' '])),
    (l()(),import2.ɵeld(0,(null as any),(null as any),4,'a',[
      [
        'md-button',
        ''
      ]
      ,
      [
        'target',
        '_blank'
      ]

    ]
    ,[
      [
        8,
        'href',
        4
      ]
      ,
      [
        1,
        'disabled',
        0
      ]
      ,
      [
        1,
        'aria-disabled',
        0
      ]
      ,
      [
        8,
        'tabIndex',
        0
      ]
      ,
      [
        2,
        'mat-button',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import2.ɵnov(v,25)._haltDisabledEvents($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_MdAnchor_0,import3.RenderType_MdAnchor)),
      import2.ɵdid(8192,(null as any),0,import4.MdPrefixRejector,[[
        2,
        import4.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    import2.ɵdid(90112,(null as any),0,import4.MdAnchor,[
      import2.ElementRef,
      import2.Renderer,
      import4.FocusOriginMonitor
    ]
    ,(null as any),(null as any)),
    import2.ɵdid(8192,(null as any),0,import4.MdButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
    (l()(),import2.ɵted(0,['DEMO']))
  ]
  ,(ck,v) => {
    const currVal_4:any = v.context.$implicit.collaborators;
    ck(v,8,0,currVal_4);
    const currVal_6:any = v.context.$implicit.technology;
    ck(v,13,0,currVal_6);
    const currVal_7:any = v.context.$implicit.integrations;
    ck(v,15,0,currVal_7);
  },(ck,v) => {
    const currVal_0:any = true;
    ck(v,0,0,currVal_0);
    const currVal_1:any = v.context.$implicit.thumbnail;
    const currVal_2:any = v.context.$implicit.name;
    ck(v,3,0,currVal_1,currVal_2);
    const currVal_3:any = v.context.$implicit.name;
    ck(v,6,0,currVal_3);
    const currVal_5:any = v.context.$implicit.description;
    ck(v,10,0,currVal_5);
    const currVal_8:any = v.context.$implicit.github;
    const currVal_9:any = import2.ɵnov(v,19).disabled;
    const currVal_10:any = import2.ɵnov(v,19)._isAriaDisabled;
    const currVal_11:any = import2.ɵnov(v,19).tabIndex;
    const currVal_12:any = true;
    ck(v,17,0,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12);
    const currVal_13:any = v.context.$implicit.url;
    const currVal_14:any = import2.ɵnov(v,25).disabled;
    const currVal_15:any = import2.ɵnov(v,25)._isAriaDisabled;
    const currVal_16:any = import2.ɵnov(v,25).tabIndex;
    const currVal_17:any = true;
    ck(v,23,0,currVal_13,currVal_14,currVal_15,currVal_16,currVal_17);
  });
}
export function View_ProjectComponent_0(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
      (l()(),import2.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'project-container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'h2',[[
        'class',
        'subheading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['Projects'])),
    (l()(),import2.ɵeld(0,(null as any),(null as any),6,'md-grid-list',[
      [
        'portGridScaleIn',
        'visible-tile'
      ]
      ,
      [
        'role',
        'list'
      ]
      ,
      [
        'rowHeight',
        '1535:876'
      ]

    ]
      ,[[
        2,
        'mat-grid-list',
        (null as any)
      ]
      ],[[
        'window',
        'scroll'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('window:scroll' === en)) {
        const pd_0:any = ((<any>import2.ɵnov(v,7).onScroll()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_MdGridList_0,import3.RenderType_MdGridList)),
      import2.ɵdid(8192,(null as any),0,import4.MdPrefixRejector,[[
        2,
        import4.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    import2.ɵdid(1105920,(null as any),1,import4.MdGridList,[
      import2.Renderer,
      import2.ElementRef,
      [
        2,
        import4.Dir
      ]

    ]
    ,{
      cols: [
        0,
        'cols'
      ]
      ,
      gutterSize: [
        1,
        'gutterSize'
      ]
      ,
      rowHeight: [
        2,
        'rowHeight'
      ]

    }
    ,(null as any)),
    import2.ɵqud(301989888,1,{_tiles: 1}),
    import2.ɵdid(2105344,(null as any),0,import6.GridScaleInDirective,[import2.ElementRef],{
      cols: [
        0,
        'cols'
      ]
      ,
      className: [
        1,
        'className'
      ]

    }
    ,(null as any)),
    (l()(),import2.ɵand(8388608,(null as any),0,1,(null as any),View_ProjectComponent_1)),
    import2.ɵdid(401408,(null as any),0,import5.NgForOf,[
      import2.ViewContainerRef,
      import2.TemplateRef,
      import2.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:import7.ProjectComponent = v.component;
    const currVal_1:any = co.cols;
    const currVal_2:any = 20;
    const currVal_3:any = '1535:876';
    ck(v,5,0,currVal_1,currVal_2,currVal_3);
    const currVal_4:any = co.cols;
    const currVal_5:any = 'visible-tile';
    ck(v,7,0,currVal_4,currVal_5);
    const currVal_6:any = co.projects;
    ck(v,9,0,currVal_6);
  },(ck,v) => {
    const currVal_0:any = true;
    ck(v,3,0,currVal_0);
  });
}
function View_ProjectComponent_Host_0(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'port-project',([] as any[]),(null as any),[[
        'window',
        'resize'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('window:resize' === en)) {
        const pd_0:any = ((<any>import2.ɵnov(v,1).onResize()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },View_ProjectComponent_0,RenderType_ProjectComponent)),
    import2.ɵdid(57344,(null as any),0,import7.ProjectComponent,[import8.ProjectService],(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const ProjectComponentNgFactory:import2.ComponentFactory<import7.ProjectComponent> = import2.ɵccf('port-project',import7.ProjectComponent,View_ProjectComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./$$_gendir/src/app/project/project.component.ngfactory.ts